import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Icon / 24&#195;&#151;24 / MapOutline">
        <path
          id="Icon"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 19.5V4L3 3.5L9 5L14.4791 3.63022C14.8203 3.54492 15.178 3.55111 15.5161 3.64816L21.9208 5.48691L22 21L21 21.5L15 20L9.51957 21.3701C9.17919 21.4552 8.82241 21.4493 8.48505 21.3529L2 19.5ZM16 18.1884L19.9907 19.1861L19.9285 6.99572L16 5.86788V18.1884ZM14 18.1884V5.81155L10 6.81155V19.1884L14 18.1884ZM4 5.81155L8 6.81155V19.1343L4 17.9914V5.81155Z"
          fill="#21201F"
        />
      </g>
    </svg>
  )
}
